import * as React from 'react';

import * as styles from './page.css';

export const OfferCardPageLayout = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['page']}>{props.children}</div>;
};
